function FormatCnpj(cnpj: string | undefined) {
    cnpj = cnpj?.replace(/[^\d]/g, "");
    return cnpj ? cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5") : '';
}

export default FormatCnpj;
